export default "__VITE_ASSET__DLo72pXF__"